import { render, staticRenderFns } from "./solutionDetails6.vue?vue&type=template&id=1634e466&scoped=true&"
import script from "./solutionDetails6.vue?vue&type=script&lang=js&"
export * from "./solutionDetails6.vue?vue&type=script&lang=js&"
import style0 from "./solutionDetails6.vue?vue&type=style&index=0&id=1634e466&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1634e466",
  null
  
)

export default component.exports